export * from '@primeuix/themes/material/progressbar';
export { default } from '@primeuix/themes/material/progressbar';
